// extracted by mini-css-extract-plugin
module.exports = {"image":"GoAcVeGjbiKbPwl3UCfV"};